<app-icon src="assets/images/slide-down.svg" (click)="countChange.emit(count+1)"></app-icon>
<span>{{count}}</span>
<app-icon src="assets/images/slide-up.svg" (click)="countChange.emit(count-1)"></app-icon>
